function ResourcesHandlerService (apiInstance)
{
	const api = apiInstance;

	this.information = () => {
		return api.request('GET', null, '/resources', {}, {})
			.then(function (response) {
				return response.data.data;
			});
	}

  this.download = () => {
  	return api.request('POST', null, '/resources/download', {}, { responseType: 'blob' });
  }
}

export default ResourcesHandlerService;


// WEBPACK FOOTER //
// ./src/Services/ResourcesHandlerService.js